import { c as _c } from "react/compiler-runtime";
import { ProjectLaunchTarget } from "@custom-types/sdb-company-types";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { useMemo } from "react";
/**
 * Custom hook to determine interaction actions (target viewer/editor and URL) for a given markup object.
 *
 * @param {Markup} markup - The markup object for which shared actions are being determined.
 */
export function useSharedMarkupActions(t0) {
  const $ = _c(3);
  const {
    markup
  } = t0;
  const projectLaunchSettings = useAppSelector(defaultProjectLaunchTargetSelector);
  let t1;
  if (projectLaunchSettings.defaultOpenProjectTarget === ProjectLaunchTarget.webEditor && markup?.webEditorUrl) {
    t1 = projectLaunchSettings.defaultOpenProjectTarget;
  } else {
    t1 = ProjectLaunchTarget.sphereViewer;
  }
  const openTarget = t1;
  const markupHref = openTarget === ProjectLaunchTarget.sphereViewer ? markup.sphereViewerUrl : markup.webEditorUrl;
  let t2;
  if ($[0] !== markupHref || $[1] !== openTarget) {
    t2 = {
      openTarget,
      markupHref
    };
    $[0] = markupHref;
    $[1] = openTarget;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}